import { CommonBaseData } from "../shared/data/common-base-data";

export class N5041MainData extends CommonBaseData{
  // グループ区分
  public gurupukubun: string;

  // 画面ID
  public gamenId: string;

  // ファイルパス
  public filePath: string;

  // ファイル名称
  public fileName: string;

  // ファイル存在
  public existFile: boolean;

  // 臨時のフォルダ名称
  public folderName: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/n504/n5041-main-data.ts